export default __webpack_public_path__ + "static/media/r_wdt_c_2.c88e6b7f.mp3";